import { LogComponent, LogTarget } from "../../models/LogModel";
import { Pivot, PivotItem } from "@fluentui/react";
import React from "react";

import { CosmicSourceTypeEnum } from "../../models/CosmicModels";
import CrossChargeView from "./crossChargeView/CrossChargeView";
import { LogElement } from "../../models/LogModel";
import PageHeader from "../common/PageHeader";
import { Pages } from "../../models/Nav";
import PartnerView from "./partnerView/PartnerView";
import styles from "./CosmicView.less";
import { trackEventCallback } from "../../utils/AppInsights";
import { useGotoTab } from "../../hooks/useGotoPage";
import { useParams } from "react-router-dom";
import PlatformView from "./platformView/PlatformView";
import { useFlights } from "../../hooks/useSettings";

interface ICosmicViewProps {
    type: CosmicSourceTypeEnum;
}

const CosmicLogElements: Record<string, LogElement> = {
    Overview: LogElement.Overview,
    PlatformMetrics: LogElement.PlatformMetrics,
    CrossChargeDetails: LogElement.CrossChargeDetails,
};

const TabDescriptions: Record<string, string> = {
    Overview: "Below you will find details regarding Cosmic app service cores and utilization for a specified date range.",
    Partner: "Below you will find details regarding Cosmic app service cores and utilization for a specified date range.",
    PlatformMetrics: "Below you will find details regarding Cosmic platform metrics for a specified date range.",
    CrossChargeDetails: "Review and analyze cross-charge details and cost allocations."
};

const CosmicView: React.FC<ICosmicViewProps> = () => {
    const { data: flights } = useFlights();
    const { tab: curTab } = useParams();
    const gotoTab = useGotoTab();
    const currentTab = curTab || "Overview";

    const handleTabChange = (item?: PivotItem) => {
        if (!item || !item.props.itemKey) return;
        gotoTab(Pages.COSMIC, item.props.itemKey, Pages.COSMIC);
        trackEventCallback(LogComponent.CosmicTabs, CosmicLogElements[item.props.itemKey], item.props.itemKey, LogTarget.Tab);
    };

    if (!flights?.enableCosmicCogsAttributionFlight) {
        return (
            <div className={styles.page}>
                <PageHeader
                    title="COSMIC - Partner"
                    description={TabDescriptions[currentTab]}
                    link="https://o365exchange.visualstudio.com/O365%20Core/_wiki/wikis/O365%20Core.wiki/386505/Cosmic-Jaws-v2"
                    linkText="Learn more."
                    inlineLink
                />
                <PartnerView type={CosmicSourceTypeEnum.PartnerView} />
            </div>
        )
    }

    return (
        <div className={styles.page}>
            <PageHeader
                title="COSMIC"
                description={TabDescriptions[currentTab]}
                link="https://o365exchange.visualstudio.com/O365%20Core/_wiki/wikis/O365%20Core.wiki/386505/Cosmic-Jaws-v2"
                linkText="Learn more."
                inlineLink
            />
            <Pivot
                className={styles.pivot}
                overflowBehavior="menu"
                onLinkClick={handleTabChange}
                selectedKey={currentTab}>
                <PivotItem itemKey="Overview" headerText="Overview" className={styles.pivotItem}>
                    <PartnerView type={CosmicSourceTypeEnum.PartnerView} />
                </PivotItem>
                <PivotItem itemKey="PlatformMetrics" headerText="Platform Metrics" className={styles.pivotItem}>
                    <PlatformView type={CosmicSourceTypeEnum.PlatformMetrics} />
                </PivotItem>
                <PivotItem itemKey="CrossChargeDetails" headerText="Cross Charge Details" className={styles.pivotItem}>
                    <CrossChargeView type={CosmicSourceTypeEnum.CrossChargeDetails}/>
                </PivotItem>
            </Pivot>
        </div>
    );
};

export default CosmicView;